import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import useStore from '../store';
import HeroLogo from './HeroLogo';
import '../styles/cinematic.css';

const OverlayUI = ({ stage, activeCategory }) => {
    const introRef = useRef(null);
    const detailsRef = useRef(null);

    // Stage 1: Intro Fade
    useEffect(() => {
        if (stage === 'intro') {
            gsap.to(introRef.current, { opacity: 1, duration: 1 });
            gsap.to(detailsRef.current, { opacity: 0, duration: 0.5 });
        } else {
            gsap.to(introRef.current, { opacity: 0, duration: 1, pointerEvents: 'none' });
            gsap.to(detailsRef.current, { opacity: 1, duration: 1, delay: 0.5 });
        }
    }, [stage]);

    return (
        <>
            {/* Cinematic global overlays */}
            <div className="overlay-vignette" style={{ pointerEvents: 'none' }} />
            <div className="overlay-scanlines" style={{ pointerEvents: 'none' }} />
            <div className="overlay-noise" style={{ pointerEvents: 'none' }} />

            {/* Stage 1: Intro CTA */}
            <div ref={introRef} style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 100,
                pointerEvents: 'none',
                opacity: 0
            }}>
                <HeroLogo visible={true} />

                <div style={{ position: 'absolute', bottom: '10%', textAlign: 'center' }}>
                    <p className="neon-text-pink flicker-slow" style={{ fontSize: '1.2rem', letterSpacing: '0.2rem', marginBottom: '10px' }}>
                        SCROLL TO ENTER DREAMLAND
                    </p>
                    <div style={{ fontSize: '2rem', color: '#fff' }}>↓</div>
                </div>
            </div>

            {/* Stage 2: Event Details (Left 40%) */}
            <div ref={detailsRef} style={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: window.innerWidth < 768 ? '100%' : '40%',
                height: '100%',
                zIndex: 90,
                pointerEvents: 'none',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: window.innerWidth < 768 ? '20px' : '40px',
                background: window.innerWidth < 768 ? 'linear-gradient(to top, rgba(0,0,0,0.9), transparent, rgba(0,0,0,0.9))' : 'none',
                opacity: 0
            }}>
                {activeCategory ? (
                    <div style={{ textAlign: 'left' }}>
                        <h2
                            className="text-glitch neon-text-cyan"
                            data-text={activeCategory.name}
                            onClick={() => {
                                if (window.innerWidth < 768) {
                                    useStore.getState().setZoomedCategoryId(activeCategory.id);
                                }
                            }}
                            style={{
                                fontSize: window.innerWidth < 768 ? '2.5rem' : '4rem',
                                margin: '0 0 20px 0',
                                textTransform: 'uppercase',
                                lineHeight: '0.9',
                                cursor: window.innerWidth < 768 ? 'pointer' : 'default',
                                pointerEvents: 'auto'
                            }}
                        >
                            {activeCategory.name}
                        </h2>
                        <div style={{
                            width: '100px',
                            height: '4px',
                            background: 'var(--color-neon-pink)',
                            marginBottom: '20px',
                            boxShadow: '0 0 10px var(--color-neon-pink)'
                        }} />
                        <p style={{
                            fontSize: '1.1rem',
                            lineHeight: '1.6',
                            color: '#ccc',
                            maxWidth: '80%'
                        }}>
                            Experience the pinnacle of {activeCategory.name} events at Samaarambh 10.0.
                            Competitions, showcases, and glory await.
                        </p>
                    </div>
                ) : (
                    <div style={{ opacity: 0.8, fontSize: '0.9rem', textAlign: 'center' }}>
                        {stage === 'wheel' && (
                            <div className="neon-text-cyan flicker-fast" style={{ fontSize: '1.2rem', letterSpacing: '2px' }}>
                                CLICK A CABIN TO EXPLORE EVENTS
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default OverlayUI;
